import { DatePipe, DecimalPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import * as CryptoJS from 'crypto-js';
import { Item_Seleccion } from '../models/generic/Item_Seleccion';
import { MatPaginator } from '@angular/material/paginator';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UtilitariosService {

  constructor(private _snackBar: MatSnackBar,
    private http: HttpClient
  ) { }

  LocalStorage_Obtener(parametro: string): any {
    let valorRetorno = localStorage.getItem(parametro);
    if (valorRetorno === null || valorRetorno === undefined) {
      return null;
    }
    return valorRetorno;
  }
  LocalStorage_Grabar(parametro: string, valorParametro: string) {
    localStorage.setItem(parametro, valorParametro);
  }
  LocalStorage_Eliminar(parametro: string) {
    localStorage.removeItem(parametro);
  }
  CifradoDatos_Cifrar(texto: string, pass: string): string {
    return CryptoJS.AES.encrypt(texto.trim(), pass.trim()).toString();
  }
  CifradoDatos_Descifrar(texto: string, pass: string): string {
    return CryptoJS.AES.decrypt(texto.trim(), pass.trim()).toString(CryptoJS.enc.Utf8);
  }
  VerificarContieneDatos(dato: any): boolean {
    if (dato) {
      return dato !== null && dato !== undefined;
    }
    return false;
  }
  VerificarContieneDatosTexto(dato: string): boolean {
    if (dato) {
      return dato !== null && dato !== undefined && dato !== '';
    }
    return false;
  }
  VerificarContieneDatosNumerico(dato: number): boolean {
    if (dato) {
      return dato !== null && dato !== undefined && dato > 0;
    }
    return false;
  }
  VerificarContieneDatosTextoConCero(dato: string): boolean {
    if (dato) {
      return dato !== null && dato !== undefined && dato !== '' && dato !== '0';
    }
    return false;
  }
  VerificarContieneDatosLista(dato: any[]): boolean {
    if (dato) {
      return dato !== null && dato !== undefined && dato.length > 0;
    }
    return false;
  }
  ObtenerMensajeErrorRespuesta(respuestaError: any) {
    if (this.VerificarContieneDatos(respuestaError.error)) {
      if (this.VerificarContieneDatos(respuestaError.error.respuesta)) {
        this.MensajeToast(respuestaError.error.respuesta.mensaje);
        return `${respuestaError.error.respuesta.mensaje}`;
      }
    }
    this.MensajeToast(respuestaError.message);
    return `${respuestaError.message}`;
  }

  MostrarErroresFormulario(formGroup: FormGroup) {
    for (const key in formGroup.controls) {
        if (formGroup.controls.hasOwnProperty(key)) {
            const control: FormControl = <FormControl>formGroup.controls[key];

            if (Object.keys(control).includes('controls')) {
                const formGroupChild: FormGroup = <FormGroup>formGroup.controls[key];
                this.MostrarErroresFormulario(formGroupChild);
            }

            control.markAsTouched();
        }
    }
  }

  MostrarErroresFormularioControl(formControl: FormControl) {
    if (formControl) {
      formControl.markAsTouched();
    }
  }

  ObtenerNombreMes(fechaConsulta: Date): string {
    let monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
      "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];
    
    return monthNames[fechaConsulta.getMonth()];
  }

  MensajeToast(message: string, action = '', config?: MatSnackBarConfig) {
    if (config === null || config === undefined) {
      config = new MatSnackBarConfig();
      config.duration = 5000;
    }
    return this._snackBar.open(message, action, config);
  }

  TieneVariasPalabras(descripcion: string): boolean {
    if (descripcion.indexOf(' ') > 0) {
      return true;
    } else {
      return false;
    }
  }
  ObtenerPrimeraPalabra(descripcion: string): string {
    let retorno: string = '';
    if (descripcion.indexOf(' ') > 0) {
      retorno = descripcion.substring(0, descripcion.indexOf(' '));
    } else {
      retorno = descripcion;
    }
    return retorno;
  }
  ObtenerTodaPalabra(descripcion: string): string {
    let retorno: string = '';
    if (descripcion.indexOf(' ') > 0) {
      retorno = descripcion.substring(0, descripcion.indexOf(' '));
      retorno = descripcion.replace(retorno, '');
    }
    return retorno;
  }
  TransformarTextoALista(textoTransformar: string, caracterRegistros: string = '|', caracterColumnas: string = '='): Item_Seleccion[] {
    console.log('TransformarTextoALista', textoTransformar, caracterRegistros, caracterColumnas);
    let listaItemsSeleccion: Item_Seleccion[] = [];
    if (this.VerificarContieneDatosTexto(textoTransformar)) {
      let itemsSeparados = textoTransformar.split(caracterRegistros);
      console.log(itemsSeparados);
      for (let index = 0; index < itemsSeparados.length; index++) {
        let itemAdicionar: Item_Seleccion = new Item_Seleccion();
        if (this.VerificarContieneDatosTexto(caracterColumnas) && itemsSeparados[index].includes(caracterColumnas)) {
          let itemsAdicionar = itemsSeparados[index].split(caracterColumnas);
          for (let index = 0; index < itemsAdicionar.length; index++) {
            if (index === 0) {
              itemAdicionar.id = itemsAdicionar[index];
            } else if (index === 1) {
              itemAdicionar.descripcion = itemsAdicionar[index];
            }
          }
        } else {
          itemAdicionar.id = itemsSeparados[index];
          itemAdicionar.descripcion = itemsSeparados[index];
        }
        listaItemsSeleccion.push(itemAdicionar);
      }
    }
    return listaItemsSeleccion;
  }
  ObtenerFechaTextoSinHora(fechaConversion: Date, separador: string = '-'): string {
    let fechaVerificacion: Date;
    if (typeof fechaConversion === 'string') {
      fechaVerificacion = this.ObtenerFechaDesdeString(fechaConversion);
    } else {
      fechaVerificacion = fechaConversion;
    }
    return `${fechaVerificacion.getFullYear()}${separador}${(fechaVerificacion.getMonth() + 1).toString().padStart(2, '0')}${separador}${fechaVerificacion.getDate().toString().padStart(2, '0')}`;
  }
  ObtenerFechaTextoConHora(fechaConversion: Date, separador: string = '-', separadorFechaHora: string = '', separadorHora: string = ''): string {
    let fechaVerificacion: Date;
    if (typeof fechaConversion === 'string') {
      fechaVerificacion = this.ObtenerFechaDesdeString(fechaConversion);
    } else {
      fechaVerificacion = fechaConversion;
    }  
    let fechaSeleccionada = this.ObtenerFechaSinHora(fechaVerificacion);
      return `${fechaSeleccionada.getFullYear()}${separador}${(fechaSeleccionada.getMonth() + 1).toString().padStart(2, '0')}${separador}${fechaSeleccionada.getDate().toString().padStart(2, '0')}${separadorFechaHora}${fechaConversion.getHours().toString().padStart(2, '0')}${separadorHora}${fechaConversion.getMinutes().toString().padStart(2, '0')}${separadorHora}${fechaConversion.getSeconds().toString().padStart(2, '0')}`;
  }
  ObtenerHoraTexto(fechaConversion: Date, separadorHora: string = ':'): string {
    return `${fechaConversion.getHours().toString().padStart(2, '0')}${separadorHora}${fechaConversion.getMinutes().toString().padStart(2, '0')}${separadorHora}${fechaConversion.getSeconds().toString().padStart(2, '0')}`;
  }
  ObtenerFechaSinHora(fechaValidacion: Date): Date {
    let fechaRetorno: Date = new Date(fechaValidacion.toDateString());
    return fechaRetorno;
  }
  ObtenerFechaSinHoraParaJson(fechaValidacion: Date): Date {
    let fechaRetorno: Date = new Date(fechaValidacion.toDateString());
    return new Date(Date.UTC(fechaRetorno.getUTCFullYear(), fechaRetorno.getUTCMonth(), fechaRetorno.getUTCDate()));
  }
  ObtenerFechaParaJson(fechaValidacion: Date): Date {
    return new Date(Date.UTC(fechaValidacion.getUTCFullYear(), fechaValidacion.getUTCMonth(), fechaValidacion.getUTCDate(), fechaValidacion.getUTCHours(), fechaValidacion.getUTCMinutes(), fechaValidacion.getUTCSeconds()));
  }
  ObtenerFechaDesdeString(fechaValidacion: string): Date {
      return new Date(fechaValidacion);
  }
  AdicionarDiasFecha(fecha: Date, dias: number): Date {
    let nuevaFecha = new Date(fecha);
    nuevaFecha.setDate(nuevaFecha.getDate() + dias);
    return nuevaFecha;
  }
  AdicionarMinutosFecha(fecha: Date, minutos: number): Date {
    let nuevaFecha = new Date(fecha);
    nuevaFecha.setMinutes(nuevaFecha.getDate() + minutos);
    return nuevaFecha;
  }
  AdicionarHorasFecha(fecha: Date, minutos: number): Date {
    let nuevaFecha = new Date(fecha);
    nuevaFecha.setHours(nuevaFecha.getDate() + minutos);
    return nuevaFecha;
  }
  DiferenciasDiasFechas(fechaInicial: Date, fechaFinal: Date): number {
    let timeInMilisec: number = fechaFinal.getTime() - fechaInicial.getTime();
    let daysBetweenDates: number = Math.ceil(timeInMilisec / (1000 * 60 * 60 * 24));
    return daysBetweenDates;
  }
  AbrirVinculo(url: string) {
    window.open(url, "_blank");
  }
  TransformarFecha(value:Date|string, incluirHora: boolean = false, formatoEspecifico: string = ''): string {
    // console.log('TransformarFecha', value, incluirHora, formatoEspecifico);
    if (this.VerificarContieneDatos(value)) {
      let pipe = new DatePipe("es");
      if (formatoEspecifico !== null && formatoEspecifico !== undefined && formatoEspecifico !== '') {
        // console.log(pipe.transform(value, formatoEspecifico));
        try {
          let fechaVisualizar: Date = new Date(value);
          return pipe.transform(fechaVisualizar, formatoEspecifico);
        } catch (error) {
          // console.log(`error con formato`);
          return pipe.transform(value, formatoEspecifico);  
        }
      } else {
        let formatoFecha: string = 'mediumDate';

        try {
          let fechaVisualizar: Date = new Date(value);
          if (incluirHora) {
            formatoFecha = 'medium';
            // console.log(pipe.transform(value, `${formatoFecha}`));
            return pipe.transform(fechaVisualizar, `${formatoFecha}`);
          } else {
            // console.log(pipe.transform(value, `${formatoFecha}`));
            return pipe.transform(fechaVisualizar, `${formatoFecha}`);
          }
        } catch (error) {
          // console.log(`error`);
          if (incluirHora) {
            return pipe.transform(value, `${formatoFecha}`);
          } else {
            // console.log(pipe.transform(value, `${formatoFecha}`));
            return pipe.transform(value, `${formatoFecha}`);
          }
        }
      }
    } else {
      return '';
    }
  }
  TransformarHora(value:Date|string, formatoEspecifico: string = ''): string {
    if (this.VerificarContieneDatos(value)) {
      let pipe = new DatePipe("en-US");
      if (formatoEspecifico !== null && formatoEspecifico !== undefined && formatoEspecifico !== '') {
        return pipe.transform(value, formatoEspecifico);
      } else {
        return pipe.transform(value, `hh:mm:ss`);
      }
    } else {
      return '';
    }
  }
  TransformarNumerico(value: number, _Decimales:number = null, _TipoControl: string = "conseparador"): string {
    let cantidadDecimales: string = '2';
    if (_Decimales === null) {
      if (this.VerificarContieneDatosTexto(cantidadDecimales)) {
        _Decimales = +cantidadDecimales;
      } else {
        _Decimales = 0;
      }
    }

    if ((_Decimales > 0) || _TipoControl === 'conseparador') {
      let _SinComas: string = '0';
      let _Pipe = new DecimalPipe("en-US");
      if (this.VerificarContieneDatos(value)) {
        let _CadenaSeparadaPorComa = value.toString().split(",");
        _SinComas = _CadenaSeparadaPorComa.join("");
      }
      let _ParametrosPipe = "1." + _Decimales.toString() + "-" + _Decimales.toString();
      let _ValorRetorno = _Pipe.transform(_SinComas, _ParametrosPipe);
      if(_ValorRetorno == null || _ValorRetorno == "null") {
          _ValorRetorno = "0." + "0".repeat(_Decimales);
      }
      return _ValorRetorno;
    } else {
      return value.toString();
    }
  }
  ObtenerTextoItem(valor: string): string {
    if (this.VerificarContieneDatosTexto(valor)) {
      return valor;
    }
    return '';
  }
  CalcularEdad(fechaNacimiento: Date): number {
    if (fechaNacimiento) {
        let timeDiff = Math.abs(Date.now() - <any>fechaNacimiento);
        return Math.ceil((timeDiff / (1000 * 3600 * 24)) / 365) - 1;
    } else {
        return 0;
    }
  }
  EstablecerTextoPaginado(paginator: MatPaginator) {
    if (this.VerificarContieneDatos(paginator)) {
      paginator._intl.itemsPerPageLabel = 'Registros por página: ';
      paginator._intl.firstPageLabel = 'Primera página';
      paginator._intl.lastPageLabel = 'Última página';
      paginator._intl.nextPageLabel = 'Siguiente página';
      paginator._intl.previousPageLabel = 'Página anterior';
      paginator._intl.getRangeLabel = this.getRangeLabel.bind(this);
    }
  }
  getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0 || pageSize === 0) {
      return '0 de 0';
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} de ${length}`;
  }
  async getPublicIp(): Promise<string> {
    const response = await this.http.get<{ ip: string }>('https://api.ipify.org?format=json').toPromise();
    return response.ip;
  }
}
